import React, { useState } from 'react';

import { Fab } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import EntryPopup from './entryPopup';
import AddMenu from './addMenu';
import EntryTable from './entryTable';

import { collection, doc, getDocs } from "firebase/firestore";
import { database } from '../firebaseConfig2';

//get collection info
const querySnapshot = await getDocs(collection(database, "currently_i_am"));


export default function Currently() {

//table info

const columns = [
  { id: 'date', label: 'Date', minWidth: 170 },
  { id: 'craving', label: 'Craving...', minWidth: 100 },
  { id: 'learning', label: 'Learning...', minWidth: 100 },
  { id: 'playing', label: 'Playing...', minWidth: 100 },
  { id: 'reading', label: 'Reading...', minWidth: 100 },
  { id: 'watching', label: 'Watching...', minWidth: 100 },

];

const rows = [];
querySnapshot.forEach((doc) => {
  let temprow =
    {
      id: doc.id, 
      date: doc.data().date, 
      craving: doc.data().craving,
      learning: doc.data().learning,
      playing: doc.data().playing,
      reading: doc.data().reading,
      watching: doc.data().watching
    }
    if (!rows.includes(temprow)){
      rows.push(temprow);
    }
});

//other
  const [addMenu, setAddMenu] = useState(false);
  const [updater, triggerUpdate] = useState(0);
  const [entryPopup, openPopup] = useState(false);
  const [selectedRow, setSelectedRow] = useState();

  const handleMenu = (mybool) =>{
    setAddMenu(true);
  }
  return (
    <>
        <EntryTable querySnapshot={querySnapshot} columns={columns} rows={rows} tableName="currently_i_am" updater={updater}  entryPopup={entryPopup} openPopup={openPopup} selectedRow={selectedRow} setSelectedRow={setSelectedRow}/>
        <div style={{ display: entryPopup ? 'block' : 'none' }}>
          <EntryPopup querySnapshot={querySnapshot} tableName="currently_i_am" entryPopup={entryPopup} openPopup={openPopup} selectedRow={selectedRow} setSelectedRow={setSelectedRow}/>
        </div>
        <Fab id="addbtn" color="primary" aria-label="add" onClick={()=>handleMenu(true)}>
          <AddIcon />
        </Fab>
        <div className='menucontainer' style={{ display: addMenu ? 'block' : 'none' }}>
          <AddMenu querySnapshot={querySnapshot} tableName="currently_i_am" addMenu={addMenu} setAddMenu={setAddMenu} updater={updater} triggerUpdate={triggerUpdate}/>
        </div>
    </>
  );
}